import { Category } from "./category";
import { Manufacturer } from "./manufacturer";

export interface IProduct {
  id: number;
  name: string;
  code: string;
  description: string;
  unitPrice: number;
  unitWeight: number;
  itemsInCase: number;
  casePrice: number;
  itemsInStock: number;
  casesInStock: number;
  imageUrl?: string;
  isActive: boolean;
  category: Category;
  categoryId: number;
  manufacturer: Manufacturer;
  manufacturerId: number;
  image: File | null;
  addedToCart?: boolean;
}

export class Product implements IProduct {
  id: number;
  name: string;
  code: string;
  description: string;
  unitPrice: number;
  unitWeight: number;
  itemsInCase: number;
  casePrice: number;
  itemsInStock: number;
  casesInStock: number;
  imageUrl?: string;
  isActive: boolean;
  category: Category;
  categoryId: number;
  manufacturer: Manufacturer;
  manufacturerId: number;
  image: File | null;
  addedToCart?: boolean;

  constructor(init: ProductFormValues) {
    Object.assign(this, init);
    this.isActive = true;
  }
}

export class ProductFormValues {
  id: number = 0;
  name: string = "";
  code: string = "";
  description: string = "";
  unitPrice: number = 0;
  unitWeight: number = 0;
  itemsInCase: number = 0;
  casePrice: number = 0;
  itemsInStock: number = 0;
  casesInStock: number = 0;
  imageUrl?: string = "";
  categoryId?: number;
  manufacturerId?: number;
  image: File | null = null;
  category?: Category;
  manufacturer?: Manufacturer;

  constructor(product?: ProductFormValues) {
    if (product) {
      this.id = product.id;
      this.name = product.name;
      this.code = product.code;
      this.description = product.description;
      this.unitPrice = product.unitPrice;
      this.unitWeight = product.unitWeight;
      this.itemsInCase = product.itemsInCase;
      this.casePrice = product.casePrice;
      this.itemsInStock = product.itemsInStock;
      this.casesInStock = product.casesInStock;
      this.imageUrl = product.imageUrl ?? "";
      this.categoryId = product.categoryId;
      this.manufacturerId = product.manufacturerId;
      this.category = product.category;
      this.manufacturer = product.manufacturer;
      this.image = product.image;
    }
  }
}
